import styled from 'styled-components';
export const BKJTableMainHeaderWrapper = styled.div `
  width: 100%;
  background-color: inherit;
  display: flex;
  padding: 16px 24px;
  border-bottom: 4px solid ${({ theme }) => theme.colors.Grey4};
`;
export const Text = styled.p `
  ${({ theme }) => theme.typography.Bold};
  margin: 0;
`;
//# sourceMappingURL=BKJTableMainHeader.styled.js.map